import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: 'James W.',
    location: 'Johnson City, TN',
    project: 'Forestry Mulching',
    rating: 5,
    text: "Had Holston come out to mulch about 2.5 acres of overgrown land to expand our pasture. They got it done in a single day. Property looks completely different. Would use them again.",
  },
  {
    name: 'Sarah M.',
    location: 'Kingsport, TN',
    project: 'Driveway Regrading',
    rating: 5,
    text: "Our gravel driveway washed out every time we got a heavy rain. Holston came out, repaired and regraded the whole thing, and saved us a lot of money by reusing material we didn\'t even realize was already there. Haven\'t had a single washout since.",
  },
  {
    name: 'Kevin D.',
    location: 'Baldwin, MI',
    project: 'Site Preparation',
    rating: 5,
    text: "We bought a lot and needed it cleared, graded, and prepped before our builder could start. Holston handled all of it. By the time they were done, the site was ready to go and our builder said it was one of the cleanest site preps he\'d worked on.",
  },
  {
    name: 'Greg S.',
    location: 'Bristol, TN',
    project: 'Commercial Site Development',
    rating: 5,
    text: "We contracted Holston for full site prep on a 2-acre commercial project including clearing, grading, drainage, and access road. They managed the entire scope without a hitch. Communication was excellent and the site was ready for construction on schedule.",
  },
  {
    name: 'Rick T.',
    location: 'Ohio',
    project: 'Hunting Property Development',
    rating: 5,
    text: "We had Holston out to work on our hunting property and couldn\'t be happier with how it turned out. They cut in several trails and opened up a couple of food plots in areas we had marked out. Everything was done clean and exactly where we wanted it. The property is so much more accessible and huntable now.",
  },
  {
    name: 'Scott B.',
    location: 'Bristol, TN',
    project: 'Lawn Drainage Correction',
    rating: 5,
    text: "Standing water was a constant problem in my yard after any decent rain. Holston came out, assessed the slope and drainage issues, and regraded the lawn to get the water moving in the right direction. Since they finished, the yard drains like it should and I\'m not dealing with standing water anymore. Straightforward process and they left no mess behind.",
  },
  {
    name: 'Dan H.',
    location: 'Ohio',
    project: 'Fence Line Clearing',
    rating: 5,
    text: "We needed the fence line cleared on our 300-acre property. Years of brush and tree growth along the fence had made it nearly impossible to get around the perimeter or keep up with fence maintenance. Holston came in and ran the entire fence line, clearing everything back so we can actually access it again. It was a big job and they knocked it out.",
  },
];

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-brand-black font-body">
      <Navbar />

      {/* Header */}
      <section className="relative w-full pt-32 pb-20 px-6 lg:px-12 bg-brand-charcoal">
        <div className="w-full max-w-7xl mx-auto">
          <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Client Reviews</p>
          <h1 className="font-heading font-800 text-white text-6xl md:text-7xl tracking-widest uppercase">
            Testimonials
          </h1>
          <div className="w-12 h-0.5 bg-brand-green-accent mt-5" />
        </div>
      </section>

      {/* Testimonials */}
      <main className="w-full px-6 lg:px-12 py-24">
        <div className="w-full max-w-5xl mx-auto flex flex-col gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-brand-charcoal border border-brand-charcoal-mid p-10 grid grid-cols-1 md:grid-cols-4 gap-8"
            >
              {/* Left: Info */}
              <div className="md:col-span-1 flex flex-col gap-2 justify-start">
                <div className="flex gap-1 mb-2">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-brand-green-accent text-sm" />
                    </div>
                  ))}
                </div>
                <p className="font-heading font-700 text-white text-lg tracking-wider uppercase">{t.name}</p>
                <p className="font-body text-xs text-gray-500">{t.location}</p>
                <div className="mt-3 px-3 py-1.5 bg-brand-green/20 border border-brand-green-mid inline-block">
                  <p className="font-heading text-xs text-brand-green-accent tracking-wider uppercase">{t.project}</p>
                </div>
              </div>

              {/* Right: Quote */}
              <div className="md:col-span-3 flex items-center">
                <div>
                  <div className="w-6 h-6 flex items-center justify-center mb-4">
                    <i className="ri-double-quotes-l text-brand-green-accent text-3xl" />
                  </div>
                  <p className="font-body text-gray-300 text-base leading-relaxed">
                    {t.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* CTA */}
      <section className="w-full bg-brand-charcoal py-16 px-6 lg:px-12">
        <div className="w-full max-w-7xl mx-auto text-center">
          <h3 className="font-heading font-800 text-white text-3xl md:text-4xl tracking-widest uppercase mb-4">
            Ready for Results Like These?
          </h3>
          <p className="font-body text-gray-400 text-sm mb-8 max-w-md mx-auto">
            Contact us today to discuss your land management project. Based in Northeast TN, serving customers nationwide.
          </p>
          <Link
            to="/contact"
            className="inline-block px-10 py-4 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-white text-lg tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
          >
            Get a Free Quote
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
